export function mergeObjects(a, b, concat_arrays) {
    const merged = a;
    for (let prop in b) {
        const previousValue = merged[prop];
        let incomingValue = b[prop];
        let mergedValue = incomingValue;
        if (prop in merged) {
            switch (typeof incomingValue) {
                case "object":
                    if (Array.isArray(incomingValue)) {
                        if (Array.isArray(merged[prop]) && concat_arrays) {
                            mergedValue = previousValue.concat(incomingValue);
                        }
                    } else {
                        mergedValue = mergeObjects(previousValue, incomingValue, concat_arrays);
                    }
                    break;
                default:
                    break;
            }
        }
        merged[prop] = mergedValue;
    }
    return merged;
}